import { FC, PropsWithChildren } from 'react';
import Collapsible from 'react-collapsible';
import { Tooltip } from '../../../components/Tooltip';
import { DangerousHTML } from '../../../components/DangerousHTML';
import { InfoCircle } from '../../../components/InfoCircle';

type BaseFilterProps = {
  title: string;
  // eslint-disable-next-line react/require-default-props
  tooltip?: string;
  opened: boolean;
  // eslint-disable-next-line react/require-default-props
  unit?: string;
};

export const BaseFilter: FC<PropsWithChildren<BaseFilterProps>> = ({ children, title, unit, tooltip, opened }) => {
  return (
    <Collapsible
      containerElementProps={{ 'aria-label': title + Date.now() }}
      trigger={
        <span className="ais-Panel-header">
          <span className="ais-Panel-header__column">
            <span>
              {title}
              {unit && <span style={{ textTransform: 'initial' }}> [{unit}]</span>}
            </span>
            {tooltip && <Tooltip tooltipAnchor={<InfoCircle />} tooltipContent={<DangerousHTML content={tooltip} />} />}
          </span>
        </span>
      }
      open={opened}
    >
      <div
        style={{
          overflowY: 'auto',
          maxHeight: 248,
        }}
      >
        {children}
      </div>
    </Collapsible>
  );
};
